"use client";

import { useState } from "react";
import { footer } from "@/content";

export default function WaitlistForm() {
  const [email, setEmail] = useState("");
  const [state, setState] = useState<"idle" | "busy" | "done" | "error" | "invalid">("idle");

  async function onSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    if (state === "busy") return;
    setState("busy");
    try {
      const res = await fetch("/api/waitlist", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      if (res.ok) {
        setState("done");
        setEmail("");
      } else if (res.status === 400) {
        setState("invalid");
      } else {
        setState("error");
      }
    } catch {
      setState("error");
    }
  }

  if (state === "done") {
    return (
      <p role="status" className="rounded-lg border border-moss-400/50 bg-moss-400/10 px-4 py-3 text-sm text-parch-100">
        ✓ {footer.waitlist.success}
      </p>
    );
  }

  return (
    <div>
      <form onSubmit={onSubmit} className="flex flex-col gap-2 sm:flex-row">
        <label htmlFor="waitlist-email" className="sr-only">
          Email address
        </label>
        <input
          id="waitlist-email"
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder={footer.waitlist.placeholder}
          className="w-full flex-1 rounded-lg border border-ink-600 bg-ink-950 px-4 py-3 text-sm text-parch-100 placeholder:text-parch-400 focus:border-ember-400 focus:outline-none focus:ring-1 focus:ring-ember-400"
        />
        <button
          type="submit"
          disabled={state === "busy"}
          className="rounded-lg bg-ember-400 px-5 py-3 text-sm font-semibold text-ink-950 transition-colors hover:bg-ember-300 disabled:opacity-60 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ember-300"
        >
          {state === "busy" ? "…" : footer.waitlist.button}
        </button>
      </form>
      {state === "invalid" ? (
        <p role="alert" className="mt-2 text-xs text-blood-400">
          {footer.waitlist.invalid}
        </p>
      ) : null}
      {state === "error" ? (
        <p role="alert" className="mt-2 text-xs text-blood-400">
          {footer.waitlist.error}
        </p>
      ) : null}
    </div>
  );
}
